import { createStore } from 'redux/core'

// import en from 'translations/en.json'
// import es from 'translations/es.json'

import entry from './entry'


const { store, storeEvents } = createStore(window.__initialState__)
const translationMessages = { en: {}, es: {} }

entry(store, storeEvents, translationMessages, false)
